import { compose } from 'recompose';

import SideBarItemView from './SideBarItemView';

export default compose()(SideBarItemView);
